<template>
  <div class="w-20 h-2 bg-how-work-line bg-no-repeat"/>
</template>

<script>
export default {
  name: 'GradientLine'
}
</script>
